"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var smartimagesrc_1 = require("@ezbuy/smartimagesrc");
var app_1 = require("services/page/app");
var admin_1 = require("services/page/admin");
var Image_1 = require("../../../components/Image");
var mTime_1 = require("../../../utils/mTime");
var time_1 = require("../../../../utils/time");
var isomorphismConstant_1 = require("../../../../utils/isomorphismConstant");
var website_1 = require("../../../../utils/website");
var lang_1 = require("../../../../utils/lang");
var mutil_Language_1 = require("../../../utils/mutil-Language");
var css_1 = require("../../../utils/css");
var s = require("./index.scss");
function hasValidState(bannerState) {
    return [admin_1.TActState.ComingSoon, admin_1.TActState.OnGoing].includes(bannerState);
}
var CountDownBanner = (function (_super) {
    __extends(CountDownBanner, _super);
    function CountDownBanner(props) {
        var _this = _super.call(this, props) || this;
        _this.getLang = lang_1.getLitbLangFn();
        _this.countDown = function (left, bannerState, id) {
            if (_this.countDownTimer) {
                clearInterval(_this.countDownTimer);
            }
            _this.countDownTimer = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, detail;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!(left < 0)) return [3, 5];
                            _a = bannerState;
                            switch (_a) {
                                case admin_1.TActState.ComingSoon: return [3, 1];
                                case admin_1.TActState.OnGoing: return [3, 3];
                            }
                            return [3, 4];
                        case 1: return [4, this.getFrontModules(id)];
                        case 2:
                            detail = _b.sent();
                            if (detail &&
                                detail.module &&
                                detail.module.state &&
                                detail.module.state === admin_1.TActState.OnGoing) {
                                clearInterval(this.countDownTimer);
                                left =
                                    detail.module.timer && detail.module.timer.time && detail.module.timer.time.left;
                                this.setState({
                                    leftObj: mTime_1.secToTimeArr(left, bannerState),
                                    bannerState: admin_1.TActState.OnGoing,
                                    detail: detail
                                });
                                this.countDown(left, admin_1.TActState.OnGoing, detail.id);
                            }
                            return [3, 4];
                        case 3:
                            clearInterval(this.countDownTimer);
                            this.setState({
                                bannerState: admin_1.TActState.Ended
                            });
                            return [3, 4];
                        case 4: return [2];
                        case 5:
                            this.setState({
                                leftObj: mTime_1.secToTimeArr(left--, bannerState)
                            });
                            return [2];
                    }
                });
            }); }, 1000);
        };
        _this.getFrontModules = function (id) { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = null;
                        return [4, app_1.GetFrontModules({
                                moduleId: [id],
                                meta: {
                                    catalog: isomorphismConstant_1.default.country,
                                    lang: isomorphismConstant_1.default.language,
                                    client: website_1.isPC() ? "web" : "mweb",
                                    priceSymbol: isomorphismConstant_1.default.currency
                                }
                            }).then(function (_a) {
                                var mods = _a.mods;
                                result = mods[id];
                            })];
                    case 1:
                        _a.sent();
                        return [2, result];
                }
            });
        }); };
        _this.state = {
            leftObj: null,
            bannerState: admin_1.TActState.UnkonwnActState,
            detail: _this.props.moduleDetail
        };
        return _this;
    }
    CountDownBanner.prototype.componentDidMount = function () {
        var moduleDetail = this.props.moduleDetail;
        var left, bannerState;
        if (moduleDetail && moduleDetail.module) {
            bannerState = moduleDetail.module.state;
            this.setState({
                detail: moduleDetail,
                bannerState: bannerState
            });
            if (moduleDetail.module.timer && moduleDetail.module.timer.time.left) {
                left = moduleDetail.module.timer.time.left;
                this.setState({
                    leftObj: mTime_1.secToTimeArr(left, bannerState)
                });
                if (bannerState === admin_1.TActState.ComingSoon || bannerState === admin_1.TActState.OnGoing) {
                    var id = moduleDetail.id;
                    this.countDown(left, bannerState, id);
                }
            }
        }
    };
    CountDownBanner.prototype.render = function () {
        var _a = this.props, index = _a.index, addModuleMap = _a.addModuleMap, commonProps = _a.commonProps;
        var _b = this.state, detail = _b.detail, leftObj = _b.leftObj, bannerState = _b.bannerState;
        var banner, start, day, hour, min, sec;
        if (detail && detail.module) {
            if (detail.module.banner) {
                banner = detail.module.banner;
            }
            if (detail.module.timer) {
                start = detail.module.timer.time.start;
                start = start && time_1.EnFormateDate(Number(start) * 1000);
                if (leftObj) {
                    day = leftObj.day;
                    hour = leftObj.hour;
                    min = leftObj.min;
                    sec = leftObj.sec;
                }
            }
        }
        var height = css_1.formatBannerSize({ width: banner.width, height: banner.height }).height;
        return (React.createElement("div", { ref: function (node) {
                if (node) {
                    addModuleMap(index, node, "#" + commonProps.id);
                }
            } },
            React.createElement(React.Fragment, null, banner ? (React.createElement("div", { className: s.CountDownBanner, style: { height: hasValidState(bannerState) ? height : "auto" } },
                hasValidState(bannerState) && (React.createElement(React.Fragment, null,
                    React.createElement(Image_1.default, { src: smartimagesrc_1.makeImageUrls(mutil_Language_1.multilingualImgDisplay(banner), {
                            online: true,
                            qnParams: { w: 750 },
                            keepSize: true,
                            aliSize: 7.5
                        })[0], isLazyLoad: true, style: {
                            width: "100%"
                        }, useOriginSrc: true, params: "imageView2/0/w/750", alisize: 7.5 }),
                    React.createElement("div", { className: s.content },
                        React.createElement("div", { className: s.box },
                            React.createElement("p", { className: s.title },
                                admin_1.TActState.ComingSoon === bannerState &&
                                    this.getLang("Starts On") + " " + start,
                                admin_1.TActState.OnGoing === bannerState &&
                                    this.getLang("Ends In") + " " + day + " days"),
                            React.createElement("div", { className: s.time },
                                hour.split("").map(function (item, i) { return (React.createElement("div", { key: i, className: s.num }, item)); }),
                                React.createElement("div", { className: s.symbol }, ":"),
                                min.split("").map(function (item, i) { return (React.createElement("div", { key: i, className: s.num }, item)); }),
                                React.createElement("div", { className: s.symbol }, ":"),
                                sec.split("").map(function (item, i) { return (React.createElement("div", { key: i, className: s.num }, item)); })))))),
                bannerState === admin_1.TActState.Ended && (React.createElement("div", { className: s.end }, this.getLang("We‘re sorry，the offer has expired."))))) : null)));
    };
    return CountDownBanner;
}(React.Component));
exports.default = CountDownBanner;
